import React, { useState } from 'react';
import './emp-payroll.css';
import { FaUser } from "react-icons/fa";
import { Row, Col, Button, Form } from 'react-bootstrap';
import PayrollInfoLayout from '../../../Components/PayrollInfoLayout.jsx';
import { utils, writeFile } from 'xlsx'; // For Excel export
import jsPDF from 'jspdf'; // For PDF export
import 'jspdf-autotable'; // For table in PDF

// Sample Employee data with pagination mock, updated according to table header
const empData = Array.from({ length: 10 }, (_, index) => ({
  id: index + 1,
  startDate: `2023-09-${index + 1}`, // Start Date
  endDate: `2023-10-${index + 1}`,   // End Date
  month: 'September',                // Month
  year: '2023',                      // Year
  workedHours: (150 + index).toFixed(2), // Worked Hours
  monthHours: 160,                   // Month Hours
  hourlyRate: (15 + index).toFixed(2), // Hourly Rate
  overtimeRate: (20 + index).toFixed(2), // Overtime Rate
  netRate: (2500 + index * 10).toFixed(2), // Net Rate
}));

export default function PayrollInfo() {
  const rowsPerPage = 10;
  const [currentPage] = useState(1); // Fix the currentPage to always be 1

  // Paginate data (in this case, it's only one page)
  const paginatedData = empData.slice(0, rowsPerPage);

  // Function to handle opening the modal

  // Function to export to Excel
  const handleExcelExport = () => {
    const worksheet = utils.json_to_sheet(empData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Payroll Data");
    writeFile(workbook, "Employee_Payroll_Data.xlsx");
  };

  // Function to export to PDF
  const handlePdfExport = () => {
    const doc = new jsPDF();
    doc.text("Employee Payroll Information", 20, 10);
    doc.autoTable({
      head: [['SR', 'Start Date', 'End Date', 'Month', 'Year', 'Worked Hours', 'Month Hours', 'Hourly Rate', 'Overtime Rate', 'Net Rate']],
      body: empData.map((emp, index) => [
        index + 1,
        emp.startDate,
        emp.endDate,
        emp.month,
        emp.year,
        emp.workedHours,
        emp.monthHours,
        emp.hourlyRate,
        emp.overtimeRate,
        emp.netRate,
      ]),
    });
    doc.save('Employee_Payroll_Data.pdf');
  };

  return (
    <>
      <PayrollInfoLayout>
        <h1 className='emps-payroll-title'><FaUser />Employee's Name</h1>
        <hr />
        <div className="emps-payroll-content">
          <div>
            <div className="entries-search-container">
              <Row>
                <Col xs={12} md={6} className="d-flex align-items-center mb-2">
                  <Button className='btn btn-secondary' onClick={handlePdfExport}>Pdf</Button>
                  <Button className='btn btn-secondary' onClick={handleExcelExport}>Excel</Button>
                </Col>
                <Col xs={12} md={6} className="d-flex justify-content-end mb-3 search-container">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="search-input"
                    />
                  </Form>
                </Col>
              </Row>
            </div>
            <div className="table-responsive">
              <table className='table table-striped'>
                <thead className='table-header'>
                  <tr className="emps-payroll-table-header">
                    <th>SR</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Month</th>
                    <th>Year</th>
                    <th>Worked Hours</th>
                    <th>Month Hours</th>
                    <th>Hourly Rate</th>
                    <th>Overtime Rate</th>
                    <th>Net Rate</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((emp, index) => (
                      <tr className="table-row" key={emp.id}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                        <td>{emp.startDate}</td>
                        <td>{emp.endDate}</td>
                        <td>{emp.month}</td>
                        <td>{emp.year}</td>
                        <td>{emp.workedHours}</td>
                        <td>{emp.monthHours}</td>
                        <td>{emp.hourlyRate}</td>
                        <td>{emp.overtimeRate}</td>
                        <td>{emp.netRate}</td>
                        <td>
                          --
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center">No data available</td>
                    </tr>
                  )}
                </tbody>
                <tfoot className='table-footer'>
                  <tr className='emps-payroll-table-footer'>
                    <td>Total</td>
                    <td>-</td>
                    <td>0</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>

                  </tr>
                </tfoot>
              </table>
              <div className="pagination-container">
                <Row className="custom-row">
                  <Col xs={12} md={9} className="custom-col-left">
                    Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, empData.length)} of {empData.length} entries
                  </Col>
                  <Col xs={12} md={3} className="custom-col-right">
                    <nav>
                      <ul className="pagination">
                        <li className="page-item active">
                          <a href="/#" className="page-link">
                            1
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </PayrollInfoLayout>
    </>
  );
}
